import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const claveCamelCase = (clave) => {
  const acronimo = clave.match(/^[A-Z]+(?=[A-Z][a-z]|\d|$)/)?.[0];
  if (acronimo) return `${acronimo.toLowerCase()}${clave.slice(acronimo.length)}`;
  return `${clave.charAt(0).toLowerCase()}${clave.slice(1)}`;
};

const normalizarDatos = (valor) => {
  if (Array.isArray(valor)) return valor.map(normalizarDatos);
  if (!valor || typeof valor !== "object") return valor;
  return Object.fromEntries(Object.entries(valor).map(([clave, dato]) => [
    claveCamelCase(clave), normalizarDatos(dato),
  ]));
};

const normalizarRespuesta = (respuesta) => respuesta?.data
  ? { ...respuesta, data: normalizarDatos(respuesta.data) }
  : respuesta;

const post = async (endpoint, request, opciones = {}) => {
  const controller = new AbortController();
  let vencido = false;
  const abortar = () => controller.abort();
  opciones.signal?.addEventListener?.("abort", abortar, { once: true });
  const timer = setTimeout(() => { vencido = true; controller.abort(); }, opciones.timeoutMs ?? 30000);
  try {
    const respuesta = await _Componentes_WebApiCalls_Post(`NotasCredito/${endpoint}`, request, {
      ...opciones, signal: controller.signal,
    });
    return vencido
      ? { error: "La operación demoró más de lo esperado. Podés reintentar sin perder el borrador.", esTimeout: true }
      : respuesta;
  } finally {
    clearTimeout(timer);
    opciones.signal?.removeEventListener?.("abort", abortar);
  }
};

export const obtenerFacturasDisponibles = (request, opciones) =>
  post("FacturasDisponibles", request, opciones).then(normalizarRespuesta);

export const obtenerDetalleNotaCredito = ({ empresaId, facturaId }, opciones) =>
  post("DetalleFactura", { empresaId, facturaId: Number(facturaId) }, opciones).then(normalizarRespuesta);

export const obtenerNotasAsociadas = ({ empresaId, facturaId }, opciones) =>
  post("NotasAsociadas", { empresaId, facturaId: Number(facturaId) }, opciones).then(normalizarRespuesta);

export const generarNotaCredito = (request, opciones) =>
  post("Generar", request, { ...opciones, preservarDatosConError: true }).then(normalizarRespuesta);
